<template>
	<div class="doughnut-chart">
		<canvas class="doughnut-chart__chart" :id="`js_doughnutChart${chartIndex}`"></canvas>
	</div>
</template>

<script>
import moment from 'moment'
import Chart from 'chart.js/auto'
moment.locale('ja')

export default {
	name: 'DoughnutChart',
	props: {
		probability: {
			type: Number,
			required: true
		},
		restProbability: {
			type: Number,
			required: true
		},
		segmentColor: {
			type: Array,
			require: true
		},
		chartIndex: {
			type: Number,
			required: true
		}
	},
	data () {
		return {
			doughnutChart: null
		}
	},
	mounted () {
		this.initChart()
	},
	methods: {
		initChart () {
			// グラフ描画コンテキスト取得
			const ctx = document.getElementById(`js_doughnutChart${this.chartIndex}`)

			// ラインチャートの設定
			const data = {
				datasets: [{
					data: [this.probability, this.restProbability],
					backgroundColor: this.segmentColor, // セグメントの色
					borderWidth: 0, // セグメントの境界線の幅
					borderRadius: this.probability !== 100 ? [10, 0] : [0, 0], // セグメントの端の丸み
					cutout: '75%', // 中央の空白の大きさ
					rotation: 0 // グラフ「0%」の開始位置
				}]
			}

			// オプション設定
			const options = {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					tooltip: {
						enabled: false // ツールチップを非表示にする
					}
				},
				rotation: -90, // 開始角度（-90度で上部から開始）
				circumference: 360, // 円の表示範囲（360度で円）
				customValueProbability: this.probability // beforeDraw内でpropsの値を使用できるようにする
			}

			// 円の中心にスコアなど表示
			const pluginsScore = {
				beforeDraw (chart, args, options) {
					const { ctx, chartArea: { top, width, height } } = chart
					ctx.save()
					ctx.fillStyle = '#ffcfcd'
					ctx.fillStyle = 'black'
					ctx.fillRect(width / 2, top + (height / 2), 0, 0)
					ctx.textAlign = 'center'
					// 位置調整
					// タイトルテキスト
					ctx.font = '400 16px "M+ C Type-1 (basic latin) Regular", "M+ Type-1 (general-j) Regular", "sans-serif"'
					ctx.fillText('免疫力', width / 2, top + (height / 2) - 24)
					// 点数テキスト
					ctx.font = '500 32px "M+ C Type-1 (basic latin) Medium", "M+ Type-1 (general-j) Medium", "sans-serif"'
					ctx.fillText(`${chart.options.customValueProbability}点`, width / 2, top + (height / 2) + 10)
				}
			}

			// 円に背景色を追加
			const pluginsLineColor = {
				beforeDraw (chart) {
					const { ctx, chartArea: { top, bottom, left, right, width, height } } = chart
					// console.log(chart)
					const outerRadius = Math.min(width, height) / 2
					// console.log('outerRadius', outerRadius)
					const innerRadius = outerRadius * 0.75
					const centerX = (left + right) / 2
					const centerY = (top + bottom) / 2

					// ドーナツ部分の背景色を描画
					ctx.save()
					ctx.fillStyle = '#FFCACA' // 背景色

					// 外円と内円の間に背景色を描画
					ctx.beginPath()
					ctx.arc(centerX, centerY, outerRadius, 0, 2 * Math.PI) // 外円
					ctx.arc(centerX, centerY, innerRadius, 0, 2 * Math.PI, true) // 内円
					ctx.closePath()
					ctx.fill()
					ctx.restore()
				}
			}

			// チャートの描画
			this.doughnutChart = new Chart(ctx, {
				type: 'doughnut',
				data: data,
				options: options,
				plugins: [pluginsLineColor, pluginsScore]
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止

.doughnut-chart {
	width: 100%;
	height: 160px;
}
</style>
